import { renderAppInstaller } from './renderAppInstaller';
import type { InstallAppApi } from '@wix/app-installer/internal-use';

export const installAppApi: InstallAppApi = async (props) => {
  const {
    silentInstall = false,
    avoidPostInstallation = false,
    ...rest
  } = props;

  return renderAppInstaller({
    silentInstall,
    avoidPostInstallation,
    ...rest,
  });
};
